import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Rounded pill container that any flow-surface toolbar can compose into.
 * Callers supply primitives (or custom buttons) as children.
 */ export function FlowToolbar({ children }) {
    return /*#__PURE__*/ _jsx("div", {
        className: "flex items-center gap-1 rounded-xl border bg-background px-2 py-1 shadow-md",
        children: children
    });
}
/** Thin vertical rule for separating logical groups of toolbar buttons. */ export function FlowToolbarDivider() {
    return /*#__PURE__*/ _jsx("div", {
        className: "mx-1 h-6 w-px bg-border"
    });
}

//# sourceMappingURL=FlowToolbar.js.map